<template>
    <control-panel
        :breadcrumbs="breadcrumbsItems"
        :title="$t('app.sidebar_items.indicators')">

        <template #right>
            <indicators-filters>
                <template #prepend>
                    <div class="btns-cont">
                        <SearchBar
                            @search="(e)=>{searcher(e)}"
                            @clear="(e)=>{searcher(e)}"
                            :placeHolder="$t('indicators.search')"
                        />
                        <span>{{ search }}</span>
                    </div>
                </template>
            </indicators-filters>
        </template>
    </control-panel>
</template>

<script>
import ControlPanel from "@/Shared/ControlPanel";
import SearchBar from "@/Shared/Users/SearchBar";
import IndicatorsFilters from "./IndicatorsFilters.vue";

export default {
    name: "IndicatorsHeader",

    components: {
        ControlPanel,
        IndicatorsFilters,
        SearchBar
    },

    props: {
        type: {
            type: Object,
        },
    },

    data() {
        return {
            search:"",
            breadcrumbsItems: [
                {
                    text: this.type.title,
                    disabled: true,
                },
                {
                    text: this.$t('indicators.types.manage'),
                    disabled: false,
                    href: route('indicators.index', {'type': this.type.id}),
                },
            ],
        }
    },

    methods: {
        searcher(e){
                this.$emit("changeSearch",e)
            },
    }

}
</script>

<style scoped>

</style>
